import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchSuppliers({ data }) {
  const { search, ...rest } = data;
  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  try {
    // const response = yield axios.get(`${baseURL}/api/v1/activity_types`, {
    const response = yield axios.get(`${baseURL}/supplier`, {
      params: { ...rest, ...(Object.keys(search).length > 0 && { ...search }) },
    });
    if (response.status === 200) {
      yield put(actions.fetchSuppliersSuccess(response.data.suppliers));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchSuppliersError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateSupplier({ data }) {
  const { name, id } = data;
  try {
    const response = yield axios.patch(`${baseURL}/supplier/${id}`, {
      name,
    });
    if (response.status === 200) {
      AntdAlert.success("Supplier updated successfully");
      yield put(actions.updateSupplierSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateSupplierError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateSupplierError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteSupplier({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(`${baseURL}/supplier/${id}`);

    if (response.status === 200) {
      AntdAlert.success("Supplier deleted successfully");
      yield put(actions.deleteSupplierSuccess(id));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.deleteSupplierError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteSupplierError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateSupplier({ data }) {
  try {
    const response = yield axios.post(`${baseURL}/supplier`, {
      name: data.name,
    });

    console.log(response);
    if (response.status === 201) {
      AntdAlert.success("Supplier created successfully");
      yield put(actions.createSupplierSuccess(response.data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createSupplierError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.createSupplierError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
